import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { DocumentModalService } from 'src/app/provide/document-modal.service';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  emailRegex =
    /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i;
  footerpage!: UntypedFormGroup;
  activeButton: any;
  currUrl: any;
  emailN: any;
  categoryListArray: any[] = [];
  subCategoryMap: { [key: string]: any[] } = {};
  
  // Static subcategories with links
  staticSubCategories = [
    { name: 'Electronics', link: '/customer-product-list', queryParams: { search: 'electronics' } },
    { name: 'Beauty', link: '/customer-product-list', queryParams: { search: 'beauty' } },
    { name: 'Fruits and Vegetables', link: '/customer-product-list', queryParams: { search: 'fruits vegetables' } },
    { name: 'Home Decor Products', link: '/customer-product-list', queryParams: { search: 'home decor' } },
    { name: 'Baby and Toddler', link: '/customer-product-list', queryParams: { search: 'baby toddler' } },
    { name: 'Appliances', link: '/customer-product-list', queryParams: { search: 'appliances' } },
    { name: 'Health Product', link: '/customer-product-list', queryParams: { search: 'health product' } }
  ];
  
  // Cache for static content to avoid multiple API calls
  private staticContentCache: { [key: string]: any } = {};
  
  constructor(
    private fb: UntypedFormBuilder,
    http: HttpClient,
    public commonService: CommonService,
    private router: Router,
    private documentModalService: DocumentModalService
  ) {}

  ngOnInit(): void {
    // this.loggedin()
    this.currUrl = this.router.url.replace(/\//g, '');

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.currUrl = this.router.url.replace(/\//g, '');
      }
    });

    this.footerpage = new UntypedFormGroup({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(
          /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i
        ),
      ]),
    });

    // Fetch categories for footer
    this.getCategoryLists();
    // this.getSocialLinks()
  }

  // Fetch categories list
  getCategoryLists() {
    let apiReqUrl: any = `admin/listCategory`;
    let apiReqData: any = {};
    apiReqData = this.commonService.removeEmptyKey(apiReqData);
    let a = this.commonService.isLoggedIn() ? 1 : 0;
    
    this.commonService.postApi(apiReqUrl, apiReqData, a).subscribe((res: any) => {
      if (res && res.responseCode == 200) {
        this.categoryListArray = res.result.docs ? res.result.docs : [];
        // Fetch subcategories for first 4 categories
        if (this.categoryListArray.length > 0) {
          const firstFourCategories = this.categoryListArray.slice(0, 4);
          firstFourCategories.forEach((category: any) => {
            if (category._id) {
              this.getSubCategoryList(category._id);
            }
          });
        }
      } else {
        this.categoryListArray = [];
      }
    }, (error) => {
      this.categoryListArray = [];
    });
  }

  // Fetch subcategories for a category
  getSubCategoryList(categoryId: string) {
    let apiReqUrl = `admin/subcategoryListWithCategory?categoryId=${categoryId}`;
    let a = this.commonService.isLoggedIn() ? 1 : 0;
    
    this.commonService.getApi(apiReqUrl, a).subscribe((res: any) => {
      if (res && res.responseCode == 200) {
        // Handle both array and object formats
        let subCategories = [];
        if (res.result) {
          // Check if subCategory is directly an array
          if (Array.isArray(res.result.subCategory)) {
            subCategories = res.result.subCategory.slice(0, 4);
          } 
          // Check if subCategory has docs property
          else if (res.result.subCategory && Array.isArray(res.result.subCategory.docs)) {
            subCategories = res.result.subCategory.docs.slice(0, 4);
          }
          // Check if result itself is an array
          else if (Array.isArray(res.result)) {
            subCategories = res.result.slice(0, 4);
          }
        }
        // Use Object.assign to trigger change detection
        this.subCategoryMap = { ...this.subCategoryMap, [categoryId]: subCategories };
      } else {
        this.subCategoryMap = { ...this.subCategoryMap, [categoryId]: [] };
      }
    }, (error) => {
      this.subCategoryMap = { ...this.subCategoryMap, [categoryId]: [] };
    });
  }

  // Navigate to category page
  navigateToCategory(categoryId: string, categoryName: string) {
    this.router.navigate(['/customer-product-list'], {
      queryParams: { categoryId: categoryId, categoryName: categoryName }
    });
  }

  // Navigate to subcategory page
  navigateToSubCategory(categoryId: string, subCategoryId: string, categoryName: string, subCategoryName: string) {
    this.router.navigate(['/customer-product-list'], {
      queryParams: { 
        categoryId: categoryId, 
        subCategoryId: subCategoryId,
        categoryName: categoryName,
        subCategoryName: subCategoryName
      }
    });
  }

  // Navigate to static subcategory
  navigateToStaticSubCategory(subCategory: any) {
    this.router.navigate([subCategory.link], {
      queryParams: subCategory.queryParams
    });
  }

  /**
   * Navigate to the appropriate static content page or show modal based on type
   * @param type The type of static content to fetch
   * @param event The click event
   */
  showDocumentContent(type: string, event: Event): void {
    event.preventDefault(); // Prevent default navigation
    
    // Map content types to their routes
    const routeMap: {[key: string]: string} = {
      'termsConditions': 'terms-and-condition',
      'privacyPolicy': 'privacy-policy',
      'aboutUs': 'aboutUs',
      'faq': 'faq'
    };
    
    // Navigate to the appropriate page
    if (routeMap[type]) {
      this.router.navigate([routeMap[type]]);
    }
  }

  // ====================================================save button================================
  getDeals() {
    console.log('Shiwani');
    if (!String(this.emailN).match(this.emailRegex)) {
      this.commonService.errorToast('Please enter valid email');
      return;
    }
    let data = {
      email: this.emailN,
      // email: this.footerpage.value.email,
    };

    let apiReqUrl: any = `user/addSubscription`;
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);
        this.commonService.showSuccessToast(res.responseMessage);
        this.emailN = '';

        // this.router.navigate(['/list-deals'])
        // localStorage.setItem('token', res.result.token)
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }
  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }
  showOrderStatus(status: any) {
    this.activeButton = status;
  }
  isEmailValid(): boolean {
    let a = String(this.emailN).match(this.emailRegex);
    return a ? false : true;
  }
}
